import { useAppSelector } from 'modules/hooks/appHooks';
import { NewRequestSelectors } from 'modules/newRequestPage/redux';
import { ActionsPathsEnum } from 'modules/newRequestPage/routes';
import { PageWithHeader, SuccessAction } from 'modules/ui';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';

export const EarlyTerminationSuccess: React.FC = () => {
  const { t } = useTranslation();
  const history = useHistory();

  const success = useAppSelector(
    NewRequestSelectors.selectEarlyContractTerminationSuccess,
  );
  const loading = useAppSelector(
    NewRequestSelectors.selectEarlyContractTerminationLoading,
  );

  return (
    <PageWithHeader
      title={t('newRequestPage.breadcrumbs.earlyTermination')}
      breadcrumbs={[
        {
          text: t('newRequestPage.breadcrumbs.newRequest'),
          url: ActionsPathsEnum.newRequestPage,
        },
        { text: t('newRequestPage.breadcrumbs.earlyTermination'), url: '' },
      ]}>
      {!loading && success !== undefined && (
        <SuccessAction
          success={success}
          title={
            success
              ? t('newRequestPage.earlyTerminationPage.successMessageTitle')
              : t('newRequestPage.earlyTerminationPage.failedMessageTitle')
          }
          description={
            success
              ? t('newRequestPage.earlyTerminationPage.successMessage')
              : t('newRequestPage.earlyTerminationPage.failedMessage')
          }
          buttonText={
            success
              ? undefined
              : t('newRequestPage.earlyTerminationPage.failedMessageButton')
          }
          onClick={success ? () => {} : () => history.goBack()}
        />
      )}
    </PageWithHeader>
  );
};
